// app/javascript/dashboard/routes/dashboard/settings/emailTemplates/builder/document/product.js
// Elemento Produto: até 3 itens do cadastro (nome, descrição e preço copiados;
// foto, link e botão ficam no bloco).
export const PRODUCT_MAX = 3;
export const PRODUCT_LAYOUTS = ['single_side', 'single_top', 'grid'];

const toPrice = value => {
  if (value === null || value === undefined || value === '') return null;
  const n = Number(value);
  return Number.isFinite(n) && n >= 0 ? Math.round(n * 100) / 100 : null;
};

// Igual ao servidor ("R$ 1.234,56"), com espaço comum no lugar do não separável.
export const formatBRL = value => {
  const n = toPrice(value);
  if (n === null) return '';
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })
    .format(n)
    .replace(/[\u00a0\u202f]/g, ' ');
};

export const productToItem = (product, base = {}) => ({
  product_id: product.id,
  name: product.name || '',
  description: product.description || '',
  price: toPrice(product.unit_price),
  old_price: base.old_price ?? null,
  media: base.media || { asset_id: null, url: null },
  url: base.url || 'https://',
  button_label: base.button_label || '',
});

// Aplica os campos relidos sobre a lista (a de agora, não a de antes do await).
export const applyRefresh = (items, fresh) =>
  (items || []).map(item =>
    item.product_id && fresh[item.product_id]
      ? { ...item, ...fresh[item.product_id] }
      : item
  );

// "Atualizar do cadastro": relê nome, descrição e preço pelo product_id.
// Só 404 é "produto apagado" (`missing`, o item fica como está); outro erro
// vai em `failed`. Itens sem product_id são ignorados. `fresh` guarda só os
// campos relidos, por product_id, para aplicar sobre a lista atual.
export const refreshItems = async (items, fetchProduct) => {
  const missing = [];
  const failed = [];
  const fresh = {};
  const linked = (items || []).filter(item => item.product_id);
  await Promise.all(
    linked.map(async item => {
      try {
        const product = await fetchProduct(item.product_id);
        fresh[item.product_id] = {
          name: product.name || item.name,
          description: product.description ?? '',
          price: toPrice(product.unit_price),
        };
      } catch (error) {
        if (error?.response?.status === 404) missing.push(item.name);
        else failed.push(item.name);
      }
    })
  );
  return { items: applyRefresh(items, fresh), fresh, missing, failed };
};
